<script setup lang="ts">
import type {Home} from '~/types/legacy'
import type {Populated} from '~/types/populated'

defineProps<{
  data: Exclude<Populated<Home>['reviews'], undefined>
}>()
</script>

<template>
  <Container
    class="screen-content mx-auto grid gap-12 px-8 py-8 md:grid-cols-2 md:gap-16 md:px-20 md:py-16 lg:grid-cols-3"
  >
    <template v-for="item of data.testimonials" :key="item.person">
      <ReviewCard v-if="item" :review="item" class="last:md:col-span-2 last:lg:col-span-1" />
    </template>
  </Container>
</template>
